(function () {
  'use strict';

  const DEBUG_POPUP = false;

  const API = 'https://loyalty-program-pi.vercel.app/api/popup';
  const PRODUCT_DELAY_SECONDS = 20; // délai minimum sur une fiche produit
  let POPUP_ID = null; // id de la popup affichée — permet des stats séparées par popup

  // Aperçu : euteyia.fr/?eut_popup=ID affiche cette popup tout de suite, même en pause,
  // sans compter dans les stats. Sert à tester une popup avant de l'activer.
  const PREVIEW_ID = (() => {
    try { return new URLSearchParams(location.search).get('eut_popup'); } catch (_) { return null; }
  })();

  const JOINED_KEY  = 'eut_popup_joined';   // permanent — a cliqué le CTA
  const SESSION_KEY = 'eut_popup_session';  // session — a fermé la popup cette visite
  const ATTRIBUTION_KEY = 'eut_popup_clicked';

  function getSessionId() {
    let id = localStorage.getItem('eut_popup_sid');
    if (!id) {
      id = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2);
      localStorage.setItem('eut_popup_sid', id);
    }
    return id;
  }

  function hasJoined()          { return !!localStorage.getItem(JOINED_KEY); }
  function dismissedThisSession(){ return !!sessionStorage.getItem(SESSION_KEY); }
  function markJoined()         { localStorage.setItem(JOINED_KEY, '1'); }
  function markSessionDismiss() { sessionStorage.setItem(SESSION_KEY, '1'); }
  function markAttribution()    { localStorage.setItem(ATTRIBUTION_KEY, '1'); }

  function trackEvent(event_type) {
    if (PREVIEW_ID) return;
    const customerId = window.__st?.cid ? String(window.__st.cid) : null;
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        mode: 'event',
        event_type,
        popup_id: POPUP_ID,
        session_id: getSessionId(),
        shopify_customer_id: customerId,
        page_url: location.pathname,
      }),
      keepalive: true,
    }).catch(() => {});
  }

  function injectStyles() {
    if (document.getElementById('eut-popup-style')) return;
    const style = document.createElement('style');
    style.id = 'eut-popup-style';
    style.textContent = `
      #eut-popup-overlay {
        position: fixed;
        inset: 0;
        background: rgba(21, 21, 21, 0.55);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        animation: eut-fade-in 0.3s ease;
      }
      @media (hover: hover) and (pointer: fine) {
        #eut-popup-overlay {
          cursor: var(--cursor-close-svg-url) 26 26, pointer;
        }
      }
      @keyframes eut-fade-in {
        from { opacity: 0; }
        to   { opacity: 1; }
      }
      #eut-popup-card {
        background: #fff;
        border-radius: 16px;
        overflow: hidden;
        width: min(100%, 400px);
        position: relative;
        box-shadow: 0 24px 80px rgba(0,0,0,0.22);
        animation: eut-slide-up 0.35s cubic-bezier(0.19, 1, 0.22, 1);
        cursor: default;
      }
      @keyframes eut-slide-up {
        from { opacity: 0; transform: translateY(24px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      #eut-popup-img-wrap {
        position: relative;
        display: block;
      }
      #eut-popup-img {
        width: 100%;
        aspect-ratio: 16/10;
        object-fit: cover;
        display: block;
        background: #f0f0f0;
      }
      #eut-popup-img-badge {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #fff;
        pointer-events: none;
      }
      #eut-popup-img-badge svg {
        width: 22px;
        height: auto;
        filter: drop-shadow(0 2px 6px rgba(0,0,0,0.45));
        flex-shrink: 0;
      }
      #eut-popup-img-badge span {
        font-family: 'Bicyclette', 'Helvetica Neue', sans-serif;
        font-size: 1rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        text-shadow: 0 2px 6px rgba(0,0,0,0.45);
      }
      #eut-popup-close {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: rgba(255,255,255,0.9);
        border: none;
        cursor: pointer;
        font-size: 16px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #151515;
        z-index: 2;
        padding: 0;
      }
      #eut-popup-close:hover { background: #fff; }
      #eut-popup-body {
        padding: 28px 24px 24px;
        text-align: center;
      }
      #eut-popup-title {
        font-family: 'Bicyclette', 'Helvetica Neue', sans-serif;
        font-size: 1.2rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        color: #151515;
        margin-bottom: 10px;
        line-height: 1.25;
      }
      #eut-popup-subtitle {
        font-family: 'Bricolage Grotesque', 'Helvetica Neue', sans-serif;
        font-size: 0.88rem;
        color: #666;
        line-height: 1.55;
        margin-bottom: 20px;
      }
      #eut-popup-cta {
        display: block;
        background: #151515;
        color: #fff;
        font-family: 'Bicyclette', 'Helvetica Neue', sans-serif;
        font-size: 0.82rem;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        text-decoration: none;
        padding: 14px 20px;
        border-radius: 8px;
        transition: opacity 0.2s;
      }
      #eut-popup-cta:hover { opacity: 0.82; color: #fff; }
      @media (max-width: 480px) {
        #eut-popup-overlay { padding: 20px; align-items: center; }
        #eut-popup-card { width: 100%; border-radius: 16px; }
      }

      /* ── Mode capture email ── */
      #eut-popup-form {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 4px;
      }
      #eut-popup-email {
        width: 100%;
        box-sizing: border-box;
        padding: 14px 16px;
        border: 1px solid #dcdcdc;
        border-radius: 999px;
        /* 16px imperatif : en dessous, iOS zoome sur le champ au focus */
        font-size: 16px;
        font-family: inherit;
        color: #151515;
        text-align: center;
        outline: none;
        transition: border-color 0.15s ease;
      }
      #eut-popup-email::placeholder { color: #b5b5b5; }
      #eut-popup-email:focus { border-color: #151515; }
      #eut-popup-email[aria-invalid="true"] { border-color: #e11d2a; }
      #eut-popup-submit {
        width: 100%;
        padding: 15px 16px;
        border: 0;
        border-radius: 999px;
        background: #151515;
        color: #fff;
        font-family: inherit;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
        transition: opacity 0.15s ease;
      }
      #eut-popup-submit:disabled { opacity: 0.55; cursor: default; }
      #eut-popup-error {
        color: #e11d2a;
        font-size: 12px;
        line-height: 1.4;
      }
      #eut-popup-error:empty { display: none; }
      #eut-popup-consent {
        font-size: 11px;
        line-height: 1.45;
        color: #9a9a9a;
      }
    `;
    document.head.appendChild(style);
  }

  function buildPopup(cfg) {
    injectStyles();

    const overlay = document.createElement('div');
    overlay.id = 'eut-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    overlay.innerHTML = `
      <div id="eut-popup-card">
        <button id="eut-popup-close" aria-label="Fermer">✕</button>
        ${cfg.image_url ? (() => {
          const mode = cfg.beauty_club_title_mode || 'star_title';
          let badge = '';
          if (mode === 'star_title') badge = `<div id="eut-popup-img-badge"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 113.4" aria-hidden="true"><path d="M29.5 113.4C27.7 61.5 26.3 58.8 0 55.3 26.2 51.8 27.7 49 29.5 0c1.8 48.9 3.3 51.8 29.5 55.3-26.3 3.5-27.7 6.2-29.5 58.1Z" fill="currentColor"/></svg><span>Beauty Club</span></div>`;
          else if (mode === 'title') badge = `<div id="eut-popup-img-badge"><span>Beauty Club</span></div>`;
          return `<div id="eut-popup-img-wrap"><img id="eut-popup-img" src="${cfg.image_url}" alt="" loading="lazy">${badge}</div>`;
        })() : ''}
        <div id="eut-popup-body">
          <div id="eut-popup-title">${cfg.title}</div>
          <div id="eut-popup-subtitle">${cfg.subtitle}</div>
          ${cfg.capture_email ? `
            <form id="eut-popup-form" novalidate>
              <input id="eut-popup-email" type="email" name="email" required autocomplete="email" inputmode="email" placeholder="ton@email.com" aria-label="Ton adresse email">
              <button id="eut-popup-submit" type="submit">${cfg.button_text}</button>
              <div id="eut-popup-error" role="alert" aria-live="polite"></div>
              <div id="eut-popup-consent">${cfg.consent_text || ''}</div>
            </form>
          ` : `<a id="eut-popup-cta" href="${cfg.button_url}">${cfg.button_text}</a>`}
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    trackEvent('impression');

    function close() {
      overlay.style.animation = 'eut-fade-in 0.2s ease reverse';
      setTimeout(() => overlay.remove(), 200);
    }

    // X : ferme pour cette session seulement, réapparaîtra à la prochaine visite
    document.getElementById('eut-popup-close').addEventListener('click', () => {
      trackEvent('dismiss');
      markSessionDismiss();
      close();
    });

    // Clic sur le fond
    overlay.addEventListener('click', e => {
      if (e.target === overlay) {
        trackEvent('dismiss');
        markSessionDismiss();
        close();
      }
    });

    // Touche Échap
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') {
        trackEvent('dismiss');
        markSessionDismiss();
        close();
        document.removeEventListener('keydown', onKey);
      }
    });

    if (cfg.capture_email) {
      // Mode inscription : le bouton EST le consentement (but annoncé + action positive)
      const form  = document.getElementById('eut-popup-form');
      const input = document.getElementById('eut-popup-email');
      const btn   = document.getElementById('eut-popup-submit');
      const err   = document.getElementById('eut-popup-error');

      function showSuccess() {
        document.getElementById('eut-popup-body').innerHTML = `
          <div id="eut-popup-title">${cfg.success_title || 'Bienvenue ✨'}</div>
          <div id="eut-popup-subtitle">${cfg.success_subtitle || ''}</div>
          <a id="eut-popup-cta" href="${cfg.button_url || '/'}">Découvrir mes avantages →</a>
        `;
        setTimeout(close, 5000);
      }

      form.addEventListener('submit', async e => {
        e.preventDefault();
        const email = input.value.trim();
        err.textContent = '';
        input.removeAttribute('aria-invalid');
        if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(email)) {
          err.textContent = 'Vérifie ton adresse email.';
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        const label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Un instant…';
        try {
          const r = await fetch(API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              mode: 'subscribe',
              email,
              popup_id: POPUP_ID,
              session_id: getSessionId(),
              shopify_customer_id: window.__st?.cid ? String(window.__st.cid) : null,
              page_url: location.pathname,
            }),
          });
          const d = await r.json().catch(() => ({}));
          if (!r.ok || d.error) throw new Error(d.error || 'erreur');
          markAttribution();
          markJoined();   // inscrite → on ne la relance plus jamais
          showSuccess();
        } catch (_) {
          btn.disabled = false;
          btn.textContent = label;
          err.textContent = 'Oups, réessaie dans un instant.';
        }
      });
    } else {
      // Mode lien : marque comme inscrit → plus jamais de popup
      document.getElementById('eut-popup-cta').addEventListener('click', () => {
        trackEvent('click');
        markAttribution();
        markJoined();
      });
    }
  }

  // ─── Design POP : volet en bas sur mobile, carte centrée sur ordinateur ───
  function esc(s) {
    return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function injectPopStyles() {
    if (document.getElementById('eut-pop-style')) return;
    const style = document.createElement('style');
    style.id = 'eut-pop-style';
    style.textContent = `
      #eut-pop-overlay { position: fixed; inset: 0; z-index: 99999; background: rgba(20,20,20,.55); display: flex; align-items: center; justify-content: center; padding: 16px; animation: eut-pop-fade .25s ease; }
      #eut-pop-sheet { position: relative; box-sizing: border-box; width: 100%; max-width: 400px; max-height: calc(100vh - 32px); overflow-y: auto; background: #fff; color: #141414;
        border-radius: 14px; font-family: inherit; text-align: left; box-shadow: 0 24px 80px rgba(0,0,0,.28); animation: eut-pop-up .4s cubic-bezier(.19,1,.22,1); }
      #eut-pop-media { display: block; width: 100%; height: 200px; object-fit: cover; object-position: center 62%; }
      #eut-pop-body { padding: 22px 24px 24px; }
      @media (min-width: 760px) {
        #eut-pop-sheet { max-width: 460px; }
        #eut-pop-sheet.eut-pop-has-img { max-width: 860px; display: flex; }
        #eut-pop-sheet.eut-pop-has-img #eut-pop-media { flex: 0 0 36%; width: 36%; height: auto; min-height: 100%; object-position: center 40%; }
        #eut-pop-sheet.eut-pop-has-img #eut-pop-body { flex: 1; padding: 30px 36px 26px; display: flex; flex-direction: column; justify-content: center; }
        .eut-pop-title { font-size: 27px !important; }
        .eut-pop-sub { font-size: 14.5px !important; }
        .eut-pop-cd b { font-size: 21px !important; }
        .eut-pop-cd div { padding: 6px 0 5px !important; }
        #eut-pop-form { display: flex; gap: 8px; flex-wrap: wrap; }
        #eut-pop-email { flex: 1 1 52%; }
        #eut-pop-form .eut-pop-btn { flex: 1 1 40%; margin-top: 0 !important; }
        #eut-pop-error { flex-basis: 100%; }
        .eut-pop-foot { display: flex; gap: 14px; justify-content: center; align-items: baseline; flex-wrap: wrap; }
        .eut-pop-foot .eut-pop-no, .eut-pop-foot .eut-pop-legal { width: auto; margin-top: 12px; }
      }
      @keyframes eut-pop-fade { from { opacity: 0 } to { opacity: 1 } }
      @keyframes eut-pop-up { from { transform: translateY(24px) scale(.98); opacity: 0 } to { transform: none; opacity: 1 } }
      #eut-pop-sheet * { box-sizing: border-box; }
      #eut-pop-sheet:not(.eut-pop-has-img) .eut-pop-title { margin-right: 36px; }
      #eut-pop-close { position: absolute; right: 14px; top: 14px; z-index: 2; width: 34px; height: 34px; border: 0; border-radius: 50%; background: rgba(255,255,255,.92); color: #141414; font-size: 15px; line-height: 34px; text-align: center; cursor: pointer; padding: 0; box-shadow: 0 2px 8px rgba(0,0,0,.12); }
      .eut-pop-badge { align-self: flex-start; display: inline-block; background: #141414; color: #fff; font-size: 11px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; padding: 6px 10px; border-radius: 4px; margin-top: 4px; }
      .eut-pop-title { font-size: 30px; line-height: 1.04; letter-spacing: -.02em; font-weight: 700; margin: 12px 0 0; }
      .eut-pop-sub { font-size: 15.5px; line-height: 1.45; color: #555; margin: 10px 0 0; }
      .eut-pop-cd { display: flex; gap: 8px; margin-top: 16px; text-align: center; }
      .eut-pop-cd div { flex: 1; background: transparent; color: #141414; border: 1px solid #141414; border-radius: 5px; padding: 9px 0 7px; }
      .eut-pop-cd b { display: block; font-size: 24px; font-weight: 500; line-height: 1.1; letter-spacing: .02em; }
      .eut-pop-cd span { font-size: 10px; color: #8a7d78; text-transform: uppercase; letter-spacing: .03em; }
      .eut-pop-offer { margin-top: 12px; font-size: 16px; font-weight: 700; line-height: 1.35; }
      .eut-pop-perks { display: flex; gap: 8px; margin-top: 10px; }
      .eut-pop-perks div { flex: 1; background: #f6ece8; border-radius: 12px; padding: 10px 6px; font-size: 12.5px; font-weight: 600; text-align: center; line-height: 1.25; }
      #eut-pop-form { margin: 16px 0 0; }
      #eut-pop-email { width: 100%; height: 46px; border: 1px solid #d9d0cb; border-radius: 5px; padding: 0 16px; font: inherit; font-size: 16px; color: #141414; background: #fff; outline: none; }
      #eut-pop-email:focus { border-color: #141414; }
      #eut-pop-email[aria-invalid="true"] { border-color: #e11d2a; }
      .eut-pop-btn { display: flex; align-items: center; justify-content: center; width: 100%; margin-top: 10px; min-height: 46px; text-decoration: none; cursor: pointer; }
      .eut-pop-btn:disabled { opacity: .55; cursor: default; }
      #eut-pop-error { color: #e11d2a; font-size: 12.5px; margin-top: 8px; }
      #eut-pop-error:empty { display: none; }
      .eut-pop-no { display: block; width: 100%; background: none; border: 0; text-align: center; font: inherit; font-size: 13px; color: #8a7d78; text-decoration: underline; margin-top: 12px; cursor: pointer; padding: 0; }
      .eut-pop-legal { text-align: center; font-size: 11px; line-height: 1.4; color: #a89c97; margin-top: 10px; }
      #eut-pop-teaser { position: fixed; left: 16px; bottom: calc(16px + env(safe-area-inset-bottom)); z-index: 99998; border: 0; border-radius: 5px; background: #141414; color: #fff;
        font-family: inherit; font-size: 14px; font-weight: 600; padding: 12px 18px; box-shadow: 0 6px 20px rgba(0,0,0,.25); cursor: pointer; animation: eut-pop-up .4s ease; }
      /* Champ et bouton plus grands sur téléphone */
      @media (max-width: 759px) { #eut-pop-email { height: 52px; font-size: 16px; } .eut-pop-btn { min-height: 52px; } }

      /* Design « photo plein cadre » (Black Weeks) : carte noire, photo à droite, oreille visible */
      #eut-pop-sheet.eut-pop-photo { background-color: #0b0b0d; color: #fff; }
      @media (max-width: 759px) { #eut-pop-sheet.eut-pop-photo { background-image: none !important; } }
      .eut-pop-photo .eut-pop-shade { position: absolute; pointer-events: none; }
      .eut-pop-photo #eut-pop-media { display: block; width: 100%; height: 290px; object-fit: cover; object-position: 30% 62%; }
      .eut-pop-photo .eut-pop-shade { left: 0; right: 0; top: 190px; height: 101px; background: linear-gradient(180deg, rgba(11,11,13,0), #0b0b0d); }
      .eut-pop-photo #eut-pop-body { position: relative; padding: 4px 22px 22px; }
      .eut-pop-photo .eut-pop-badge { background: none; color: #d9d9d9; padding: 0; font-size: 12px; letter-spacing: .04em; }
      .eut-pop-photo .eut-pop-title { font-size: 36px; line-height: 1.02; margin-top: 8px; }
      .eut-pop-photo .eut-pop-sub { color: #fff; font-size: 22px; font-weight: 600; margin-top: 10px; white-space: nowrap; }
      .eut-pop-photo .eut-pop-cd div { border-color: rgba(255,255,255,.5); color: #fff; }
      .eut-pop-photo .eut-pop-cd span { color: #bdbdbd; }
      .eut-pop-photo .eut-pop-offer { color: #cfcfcf; font-weight: 400; font-size: 14px; margin-top: 10px; }
      .eut-pop-photo #eut-pop-email { border-color: #fff; }
      .eut-pop-photo .eut-pop-btn.button { --solid-button-background: #fff; --solid-button-label: #000; background: #fff !important; color: #000 !important; border-color: #fff !important; }
      .eut-pop-photo .eut-pop-no, .eut-pop-photo .eut-pop-legal { color: #a8a8a8; }
      .eut-pop-photo .eut-pop-done-badge { color: #fff; }
      @media (min-width: 760px) {
        #eut-pop-sheet.eut-pop-photo { display: block; max-width: 820px; min-height: 480px; background-repeat: no-repeat; background-position: right 72%; background-size: auto 140%; }
        .eut-pop-photo #eut-pop-media { display: none; }
        .eut-pop-photo .eut-pop-shade { inset: 0; top: 0; height: auto; background: linear-gradient(90deg, #0b0b0d 0%, #0b0b0d 42%, rgba(11,11,13,.6) 49%, rgba(11,11,13,0) 56%); }
        .eut-pop-photo #eut-pop-body { width: 47%; padding: 40px 0 30px 40px; }
        .eut-pop-photo #eut-pop-form { display: block; }
        .eut-pop-photo #eut-pop-form .eut-pop-btn { margin-top: 8px !important; }
        .eut-pop-photo .eut-pop-foot { justify-content: flex-start; }
        .eut-pop-photo .eut-pop-title { font-size: 40px !important; }
        .eut-pop-photo .eut-pop-sub { font-size: 22px !important; }
      }
    `;
    document.head.appendChild(style);
  }

  function countdownParts(to) {
    const ms = new Date(to).getTime() - Date.now();
    if (!(ms > 0)) return null;
    const d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24, m = Math.floor(ms / 60000) % 60;
    const two = n => String(n).padStart(2, '0');
    return d > 0 ? [[d, d > 1 ? 'jours' : 'jour'], [two(h), 'heures'], [two(m), 'min']]
                 : [[two(h), 'heures'], [two(m), 'min'], [two(Math.floor(ms / 1000) % 60), 'sec']];
  }

  function showTeaser(cfg) {
    if (!cfg.teaser_text || document.getElementById('eut-pop-teaser')) return;
    injectPopStyles();
    const t = document.createElement('button');
    t.id = 'eut-pop-teaser';
    t.type = 'button';
    t.textContent = cfg.teaser_text;
    t.addEventListener('click', () => { t.remove(); buildPopupPop(cfg); });
    document.body.appendChild(t);
  }

  function buildPopupPop(cfg) {
    injectPopStyles();
    const perks = String(cfg.perks || '').split('\n').map(s => s.trim()).filter(Boolean).slice(0, 3);
    const overlay = document.createElement('div');
    overlay.id = 'eut-pop-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = `
      <div id="eut-pop-sheet" class="${cfg.style === 'photo' ? 'eut-pop-photo' : (cfg.image_url ? 'eut-pop-has-img' : '')}"${cfg.style === 'photo' && cfg.image_url ? ` style="background-image:url('${esc(cfg.image_url)}')"` : ''}>
        <button id="eut-pop-close" type="button" aria-label="Fermer">✕</button>
        ${cfg.image_url ? `<img id="eut-pop-media" src="${esc(cfg.image_url)}" alt="">` : ''}
        ${cfg.style === 'photo' ? '<div class="eut-pop-shade"></div>' : ''}
        <div id="eut-pop-body">
          ${cfg.badge_text ? `<span class="eut-pop-badge">${esc(cfg.badge_text)}</span>` : ''}
          <div class="eut-pop-title">${esc(cfg.title)}</div>
          ${cfg.subtitle ? `<p class="eut-pop-sub">${esc(cfg.subtitle)}</p>` : ''}
          ${cfg.countdown_to ? `<div class="eut-pop-cd" id="eut-pop-cd"></div>` : ''}
          ${cfg.offer_text ? `<div class="eut-pop-offer">${esc(cfg.offer_text)}</div>` : ''}
          ${perks.length ? `<div class="eut-pop-perks">${perks.map(p => `<div>${esc(p)}</div>`).join('')}</div>` : ''}
          ${cfg.capture_email ? `
            <form id="eut-pop-form" novalidate>
              <input id="eut-pop-email" type="email" name="email" required autocomplete="email" inputmode="email" placeholder="ton@email.com" aria-label="Ton adresse email">
              <button class="button eut-pop-btn" id="eut-pop-submit" type="submit"><span data-content="${esc(cfg.button_text)}"></span></button>
              <div id="eut-pop-error" role="alert" aria-live="polite"></div>
            </form>
          ` : `<a class="button eut-pop-btn" id="eut-pop-cta" href="${esc(cfg.button_url || '/')}"><span data-content="${esc(cfg.button_text)}"></span></a>`}
          <div class="eut-pop-foot">
            ${cfg.decline_text ? `<button type="button" class="eut-pop-no" id="eut-pop-no">${esc(cfg.decline_text)}</button>` : ''}
            ${cfg.capture_email && cfg.consent_text ? `<div class="eut-pop-legal">${esc(cfg.consent_text)}</div>` : ''}
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    trackEvent('impression');

    // Compte à rebours : se met à jour chaque seconde, disparaît une fois la date passée
    let timer = null;
    const cdEl = document.getElementById('eut-pop-cd');
    if (cdEl) {
      const paint = () => {
        const parts = countdownParts(cfg.countdown_to);
        if (!parts) { cdEl.remove(); clearInterval(timer); return; }
        cdEl.innerHTML = parts.map(([v, l]) => `<div><b>${v}</b><span>${l}</span></div>`).join('');
      };
      paint();
      timer = setInterval(paint, 1000);
    }

    function close() {
      clearInterval(timer);
      overlay.style.animation = 'eut-pop-fade .2s ease reverse';
      setTimeout(() => overlay.remove(), 200);
    }
    function dismiss() {
      trackEvent('dismiss');
      markSessionDismiss();
      close();
      showTeaser(cfg);
    }
    document.getElementById('eut-pop-close').addEventListener('click', dismiss);
    document.getElementById('eut-pop-no')?.addEventListener('click', dismiss);
    overlay.addEventListener('click', e => { if (e.target === overlay) dismiss(); });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { document.removeEventListener('keydown', onKey); if (overlay.isConnected) dismiss(); }
    });

    if (!cfg.capture_email) {
      document.getElementById('eut-pop-cta').addEventListener('click', () => { trackEvent('click'); markAttribution(); markJoined(); });
      return;
    }

    const form = document.getElementById('eut-pop-form');
    const input = document.getElementById('eut-pop-email');
    const btn = document.getElementById('eut-pop-submit');
    const err = document.getElementById('eut-pop-error');
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const email = input.value.trim();
      err.textContent = '';
      input.removeAttribute('aria-invalid');
      if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(email)) {
        err.textContent = 'Vérifie ton adresse email.';
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      btn.disabled = true;
      btn.classList.add('loading');
      try {
        const r = await fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            mode: 'subscribe', email, popup_id: POPUP_ID, session_id: getSessionId(),
            shopify_customer_id: window.__st?.cid ? String(window.__st.cid) : null, page_url: location.pathname,
          }),
        });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || d.error) throw new Error(d.error || 'erreur');
        markAttribution();
        markJoined();
        clearInterval(timer);
        document.getElementById('eut-pop-body').innerHTML = `
          <span class="eut-pop-badge">C'est tout bon 🤍</span>
          <div class="eut-pop-title">${esc(cfg.success_title || 'Bienvenue ✨')}</div>
          ${cfg.success_subtitle ? `<p class="eut-pop-sub">${esc(cfg.success_subtitle)}</p>` : ''}
          <button type="button" class="button eut-pop-btn" id="eut-pop-done"><span data-content="Continuer mon shopping"></span></button>
        `;
        document.getElementById('eut-pop-done').addEventListener('click', close);
      } catch (_) {
        btn.disabled = false;
        btn.classList.remove('loading');
        err.textContent = 'Oups, réessaie dans un instant.';
      }
    });
  }

  // Le bandeau cookies du thème (#eutck-banner) s'affiche en bas de l'écran et recouvrait
  // le bouton de la popup sur mobile : on attend que la visiteuse y ait répondu.
  function cookieBannerVisible() {
    const b = document.getElementById('eutck-banner');
    if (!b) return false;
    const cs = getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
  }

  function show(cfg) {
    if (!PREVIEW_ID && cookieBannerVisible()) {
      const wait = setInterval(() => {
        if (cookieBannerVisible()) return;
        clearInterval(wait);
        setTimeout(() => show(cfg), 1200);
      }, 500);
      return;
    }
    if (cfg.style === 'pop' || cfg.style === 'photo') buildPopupPop(cfg);
    else buildPopup(cfg);
  }

  async function init() {
    // Aperçu demandé dans l'URL : on montre cette popup tout de suite, quoi qu'il arrive
    if (PREVIEW_ID) {
      try {
        const res = await fetch(`${API}?preview=${encodeURIComponent(PREVIEW_ID)}`, { cache: 'no-store' });
        const cfg = res.ok ? await res.json() : null;
        if (cfg) { POPUP_ID = cfg.id ?? null; setTimeout(() => show(cfg), 600); }
      } catch (_) {}
      return;
    }
    if (!DEBUG_POPUP && hasJoined()) return;

    try {
      const res = await fetch(API, { cache: 'no-store' });
      if (!res.ok) return;
      const cfg = await res.json();
      if (!cfg) return;
      if (!DEBUG_POPUP && !cfg.enabled) return;
      POPUP_ID = cfg.id ?? null;
      // Déjà fermée pendant cette visite : seule la version POP laisse un petit bouton pour la rouvrir
      if (!DEBUG_POPUP && dismissedThisSession()) {
        if (cfg.style === 'pop' || cfg.style === 'photo') showTeaser(cfg);
        return;
      }

      // Jamais sur le panier ; plus tard sur une fiche produit pour ne pas couper un ajout au panier
      if (/^\/cart/.test(location.pathname)) return;
      const base = Math.max(0, (cfg.delay_seconds ?? 10));
      const secs = /\/products\//.test(location.pathname) ? Math.max(base, PRODUCT_DELAY_SECONDS) : base;
      setTimeout(() => show(cfg), DEBUG_POPUP ? 0 : secs * 1000);
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
